// helpers.ts — Pure utility functions for D206 form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number with locale grouping, max 3 decimals (for unit prices) */
export const fmt3 = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 3 });
};

/** Derive the status badge for a D206 record */
export const getStatusBadge = (record: { fd160_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fd160_80 || '').trim();
  // 統一狀態碼（規格法定值）：N=草稿/已沖銷、D=送審中、P=已核准
  // （自創碼 S/R/V 已廢除；S 保留映射僅供顯示殘留舊值）
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  if (s80 === 'D') return { text: '送審中', cls: 'badge-warning' };
  if (s80 === 'S') return { text: '送審中(舊碼)', cls: 'badge-warning' };
  return null;
};

/** Check if record is locked for editing */
export const isLockedForEdit = (record: { fd160_80?: string } | null): boolean => {
  if (!record) return false;
  const s80 = (record.fd160_80 || '').trim();
  return ['P', 'D', 'S'].includes(s80); // 統一碼 D + 舊碼 S 過渡容忍
};

/** Map warehouse type code to display text */
export const warehouseTypeLabel = (code: string): string => {
  switch (code) {
    case 'A': return '渤揚倉庫';
    case 'B': return '工廠';
    default: return '*查無此代號*';
  }
};

/** Fields that are always readonly (computed or system) */
const ALWAYS_READONLY = new Set([
  'fd160_01',   // 單號 (system generated)
  'fd160_14',   // 總退回數量 (computed)
  'fd160_16',   // 未稅退貨總額 (computed)
  'fd160_22',   // 退貨總稅額 (computed)
  'fd160_20',   // 總項數 (computed)
  'fd160_19',   // 出庫通知單號 (功能已停用 in FoxPro)
]);

/** Determine if a field should be disabled */
export const isFieldDisabledFn = (key: string, isEditing: boolean, mode: string): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  // 修改模式時繳庫單號鎖定
  if (key === 'fd160_11' && mode === 'edit') return true;
  return false;
};
